import { defineMessages } from 'react-intl';

export default defineMessages({
    policyNumber: {
        id: 'billingtable.templates.billing-details.policyNumber',
        defaultMessage: 'Policy Number'
    },
    policyType: {
        id: 'billingtable.templates.billing-details.PolicyType',
        defaultMessage: 'Policy Type'
    },
    billingPlan: {
        id: 'billingtable.templates.billing-details.billingPlan',
        defaultMessage: 'Billing Plan',
    },
    lastPayment: {
        id: 'billingtable.templates.billing-details.lastPayment',
        defaultMessage: 'Last Payment',
    },
    lastPaymentDate: {
        id: 'billingtable.templates.billing-details.lastPaymentDate',
        defaultMessage: 'Last Payment Date',
    },
    balanceDue: {
        id: 'billingtable.templates.billing-details.balanceDue',
        defaultMessage: 'Balance Due'
    },
    paymentPlan: {
        id: "billingtable.templates.billing-details.paymentPlan",
        defaultMessage: "Payment Plan",
    },
    billingEmpty: {
        id: 'billingtable.templates.billing-details.BillingEmpty',
        defaultMessage: 'Billing Details are not associated to this account'
    },
    brokerBillingInfo: {
        id: 'billingtable.templates.billing-details.brokerBillingInfo',
        defaultMessage: 'Please contact your broker for billing information'
    },
});
